export enum DDX_MODULES {
  DDX_TAGGING_TOOL = 'DDX_TAGGING_TOOL',
  DDX_NEW_DATASET = 'DDX_NEW_DATASET',
  DDX_TRAINING_DATASETS = 'DDX_TRAINING_DATASETS',
}

export const ddxModules = Object.values(DDX_MODULES);
